/**
 * @generated SignedSource<<bb895577e294ecd11ea660bfbc970afa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EquipmentCategory = "AUDIO_VIDEO" | "BATTERY" | "CABLE" | "CAMERA" | "CAMERA_ACCESSORY" | "ETC" | "KIT" | "LENS" | "LIGHTING" | "MEDIA" | "NETWORK" | "POWER" | "PRINTER" | "SECURITY" | "WORKSTATION" | "WORKSTATION_ACCESSORY" | "%future added value";
export type GearPageQuery$variables = {
  assetTag: any;
  endOn: any;
  startOn: any;
};
export type GearPageQuery$data = {
  readonly asset: {
    readonly assetTag: any;
    readonly available: boolean;
    readonly category: EquipmentCategory;
    readonly dailyRate: any | null | undefined;
    readonly description: string | null | undefined;
    readonly id: string;
    readonly image: any | null | undefined;
    readonly kit: {
      readonly assetTag: any;
      readonly name: string;
    } | null | undefined;
    readonly kitMembers: ReadonlyArray<{
      readonly assetTag: any;
      readonly category: EquipmentCategory;
      readonly id: string;
      readonly image: any | null | undefined;
      readonly name: string;
    }>;
    readonly make: string | null | undefined;
    readonly model: string | null | undefined;
    readonly name: string;
    readonly properties: ReadonlyArray<{
      readonly key: string;
      readonly value: string;
    }>;
    readonly specifications: ReadonlyArray<string>;
  } | null | undefined;
};
export type GearPageQuery = {
  response: GearPageQuery$data;
  variables: GearPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "assetTag"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endOn"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startOn"
},
v3 = [
  {
    "kind": "Variable",
    "name": "assetTag",
    "variableName": "assetTag"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetTag",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "make",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "model",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dailyRate",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "specifications",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "Property",
  "kind": "LinkedField",
  "name": "properties",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": "available",
  "args": [
    {
      "kind": "Variable",
      "name": "endOn",
      "variableName": "endOn"
    },
    {
      "kind": "Variable",
      "name": "startOn",
      "variableName": "startOn"
    }
  ],
  "kind": "ScalarField",
  "name": "availableOn",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "kitMembers",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "GearPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Asset",
        "kind": "LinkedField",
        "name": "asset",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Asset",
            "kind": "LinkedField",
            "name": "kit",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v16/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "GearPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Asset",
        "kind": "LinkedField",
        "name": "asset",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Asset",
            "kind": "LinkedField",
            "name": "kit",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v16/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "95e8210db70cccf0cd0634d278b4c5dc",
    "id": null,
    "metadata": {},
    "name": "GearPageQuery",
    "operationKind": "query",
    "text": "query GearPageQuery(\n  $assetTag: AssetTag!\n  $startOn: ISO8601Date!\n  $endOn: ISO8601Date!\n) {\n  asset(assetTag: $assetTag) {\n    id\n    assetTag\n    name\n    make\n    model\n    description\n    category\n    image\n    dailyRate\n    specifications\n    properties {\n      key\n      value\n    }\n    available: availableOn(startOn: $startOn, endOn: $endOn)\n    kit {\n      assetTag\n      name\n      id\n    }\n    kitMembers {\n      id\n      assetTag\n      name\n      category\n      image\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "eb8855f305293fb7798aed6c68090db4";

export default node;
